import { render, staticRenderFns } from "./FormSelectTree.vue?vue&type=template&id=f8c4d900&scoped=true"
import script from "./FormSelectTree.vue?vue&type=script&lang=js"
export * from "./FormSelectTree.vue?vue&type=script&lang=js"
import style0 from "./FormSelectTree.vue?vue&type=style&index=0&id=f8c4d900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c4d900",
  null
  
)

export default component.exports